<template>
  <v-snackbar v-model="snackbar" top color="white" text timeout="6000">
    <span class="text mr-3">{{ text }}</span>
    <v-progress-circular
      v-if="loading"
      indeterminate
      color="primary"
      size="20"
      width="2"
    ></v-progress-circular>
    <template v-slot:action="{ attrs }">
      <v-btn color="primary" text v-bind="attrs" @click="snackbar = false">
        Ok
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: 'FindMyLocationSnackbar',
  data() {
    return {
      tryingToFind: false
    }
  },
  computed: {
    snackbar: {
      get() {
        return this.$store.state.findingMyLocationUI.display
      },
      set() {
        this.$store.state.findingMyLocationUI.display = false
      }
    },
    text() {
      return this.$store.state.findingMyLocationUI.text
    },
    loading() {
      return this.$store.state.findingMyLocationUI.loading
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
span.text {
  color: rgba(0, 0, 0, 0.87);
}
</style>
